import { PixelPet } from '../identity/PixelPet'
import { Avatar } from '../chat/Avatar'

/**
 * WHO SAID THE LAST THING, at 16px, on a project card's preview strip.
 *
 * An agent wears its PixelPet (seeded by its channel hash). A PERSON wears their own
 * face — owner, 2026-09-27: 在 Project Chat 的預覽圖裡面, 如果是由人類所輸入的訊息, 預覽圖
 * 並沒有顯示人類的頭像 — the same Avatar every other person on screen wears: their photo,
 * else the letter tile drawn from their address. The neutral dot is left only for a row
 * that names nobody (a backend too old to send the address).
 *
 * Shared by the project cards and the friend rows (owner, 2026-09-27: 朋友卡片也一起加上
 * 頭像), so the two strips cannot drift apart — the same reason they share .sb-plast.
 */
export function LastSpeakerFace({
  hash,
  who,
  email,
  picture,
  size = 16,
}: {
  hash: string
  who: string
  email: string
  picture: string
  /** The agent face's size. The human face and the dot are sized by the strip's CSS. */
  size?: number
}) {
  if (hash) return <PixelPet name={who || hash} seed={hash} size={size} />
  if (email || picture) {
    return <Avatar picture={picture || null} label={who || email} email={email || null} className="sb-plast-face" />
  }
  return <span className="sb-plast-dot" aria-hidden="true" />
}
